import { CSSProperties } from 'react';
import {
  COLORS,
  DISPLAY_STRETCH,
  FONTS,
  META,
} from '../../../../globalStyles';

const square: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '44px',
  background: 'transparent',
  border: `1px solid ${COLORS.borderStrong}`,
  borderRadius: 0,
  color: COLORS.text,
  fontSize: '1.1rem',
  cursor: 'pointer',
};

export const styles: Record<string, CSSProperties> = {
  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '0.75rem',
    marginTop: '2.5rem',
    marginBottom: '1.5rem',
  },
  counter: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.label,
    marginRight: 'auto',
  },
  counterCurrent: {
    color: COLORS.accent,
  },
  arrow: square,
  arrowDisabled: {
    ...square,
    opacity: 0.35,
    cursor: 'default',
  },
  track: {
    display: 'flex',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    columnGap: '4rem',
    outlineOffset: '4px',
  },
  slide: {
    flex: '0 0 100%',
    scrollSnapAlign: 'start',
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr)',
    gap: '4rem',
    alignItems: 'center',
    padding: '0 0 0.5rem 1px',
  },
  plate: {
    width: '300px',
    aspectRatio: '1206 / 2622',
    border: `1px solid ${COLORS.borderStrong}`,
    background: COLORS.surface,
    overflow: 'hidden',
  },
  shot: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  index: {
    ...META,
    display: 'block',
    fontSize: '0.72rem',
    color: COLORS.accent,
    marginBottom: '0.9rem',
  },
  title: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: 'clamp(1.9rem, 3.4vw, 2.6rem)',
    lineHeight: 1.05,
    color: COLORS.text,
  },
  lead: {
    fontSize: '1.0625rem',
    lineHeight: 1.7,
    color: COLORS.muted,
    marginTop: '1rem',
    maxWidth: '34rem',
  },
  points: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    marginTop: '1.75rem',
    maxWidth: '34rem',
  },
  point: {
    display: 'grid',
    gridTemplateColumns: '0.9rem 1fr',
    alignItems: 'baseline',
    fontSize: '1rem',
    lineHeight: 1.6,
    color: COLORS.text,
  },
  marker: {
    width: '6px',
    height: '6px',
    background: COLORS.accent,
    transform: 'translateY(-2px)',
  },
  gesture: {
    ...META,
    display: 'inline-block',
    fontSize: '0.66rem',
    color: COLORS.label,
    marginTop: '1.75rem',
    paddingTop: '1rem',
    borderTop: `1px solid ${COLORS.border}`,
  },
  dots: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.25rem',
    marginTop: '1.75rem',
  },
  dot: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
  dotMark: {
    width: '8px',
    height: '8px',
    background: COLORS.borderStrong,
  },
  dotMarkActive: {
    width: '8px',
    height: '8px',
    background: COLORS.accent,
  },
};
